import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "../services/firebase-config";
import { CircularProgress, Box, Typography } from "@mui/material";
import { t } from "@lingui/macro";

const ClientAuth = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");
    const redirect = queryParams.get("redirect") || "/";

    console.debug("🔍 Raw token from URL:", token);
    if (token && token.startsWith('"') && token.endsWith('"')) {
      console.warn("⚠️ Token has surrounding quotes, stripping...");
    }

    if (!token || token === '""') {
      console.error("❌ No token provided or token is empty.");
      navigate("/login?error=missing_token", { replace: true });
      return;
    }

    const cleanToken = token.replace(/^"|"$/g, ""); // strip " if included

    const signIn = async () => {
      try {
        console.debug("🛂 Attempting signInWithCustomToken...");
        const result = await signInWithCustomToken(auth, cleanToken);
        console.log("✅ Session login successful:", result.user);
        navigate(redirect, { replace: true });
      } catch (error) {
        console.error("❌ Session login failed:");
        console.error("📄 Message:", error.message);
        console.error("📦 Code:", error.code);
        console.error("📜 Token:", cleanToken.slice(0, 60) + "...");
        navigate("/login?error=invalid_token", { replace: true });
      }
    };

    signIn();
  }, [navigate]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      flexDirection="column"
    >
      <CircularProgress />
      <Typography sx={{ mt: 2 }}>{t`Logging you in...`}</Typography>
    </Box>
  );
};

export default ClientAuth;
